import * as React from 'react'
import { cartStore as store } from '../../../cart'
import { CheckoutProceedButton } from '../button'
import './review-order-button-wrapper.scss'

export const ReviewOrderButtonWrapper = (): JSX.Element => {
  const baseClass: string = 'review-order-button-wrapper'

  return (
    <div className={baseClass}>
      <div className="container">
        <CheckoutProceedButton
          text="Review order"
          gtmId={"cart-open"}
          onClick={store.toggleShowCart}
        />
      </div>
    </div>
  )
}
